/* Scenic Drives map (Oct 22 2026). MapLibre GL 5.24.0 from unpkg (same as Food Watch), free OpenFreeMap tiles,
   attribution on. Loads only after "Show the map" is pressed. Draws the U.S. DOT route line (when verified) and the stops. */
(function () {
  var box = document.querySelector('[data-sd-map]');
  if (!box) return;
  var LIB = 'https://unpkg.com/maplibre-gl@5.24.0/dist/maplibre-gl';
  function readJson(id) { var el = document.getElementById(id); if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function load(cb) {
    if (window.maplibregl) return cb();
    var css = document.createElement('link'); css.rel = 'stylesheet'; css.href = LIB + '.css'; document.head.appendChild(css);
    var s = document.createElement('script'); s.src = LIB + '.js'; s.onload = cb;
    s.onerror = function () { box.querySelector('[data-sd-load] p').textContent = 'The map could not load. The stops and directions below still work.'; };
    document.head.appendChild(s);
  }
  function draw() {
    var line = readJson('sd-line'), stops = readJson('sd-stops-json') || [];
    var bb = (box.getAttribute('data-bbox') || '').split(',').map(Number);
    var map = new maplibregl.Map({ container: box.querySelector('[data-sd-canvas]'), style: box.getAttribute('data-style'),
      attributionControl: { compact: true }, dragRotate: false, pitchWithRotate: false, cooperativeGestures: true });
    map.addControl(new maplibregl.NavigationControl({ showCompass: false }), 'top-right');
    var bounds = new maplibregl.LngLatBounds();
    if (bb.length === 4 && !isNaN(bb[0])) { bounds.extend([bb[0], bb[1]]); bounds.extend([bb[2], bb[3]]); }
    stops.forEach(function (s) { bounds.extend([s.lng, s.lat]); });
    map.on('load', function () {
      if (line && line.coordinates) {
        map.addSource('route', { type: 'geojson', data: { type: 'Feature', properties: {}, geometry: { type: 'MultiLineString', coordinates: line.coordinates } } });
        map.addLayer({ id: 'route-casing', type: 'line', source: 'route', layout: { 'line-cap': 'round', 'line-join': 'round' }, paint: { 'line-color': '#ffffff', 'line-width': 7 } });
        map.addLayer({ id: 'route', type: 'line', source: 'route', layout: { 'line-cap': 'round', 'line-join': 'round' }, paint: { 'line-color': '#2f6b4f', 'line-width': 4 } });
      }
      stops.forEach(function (s, i) {
        var el = document.createElement('div');
        el.style.cssText = 'width:26px;height:26px;border-radius:50%;background:#6f4b31;color:#fff;font:700 13px/26px Georgia,serif;text-align:center;border:2px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,.3)';
        el.textContent = String(i + 1);
        el.setAttribute('aria-label', s.name);
        new maplibregl.Marker({ element: el }).setLngLat([s.lng, s.lat])
          .setPopup(new maplibregl.Popup({ offset: 16 }).setHTML('<strong>' + esc(s.name) + '</strong>')).addTo(map);
      });
      if (!bounds.isEmpty()) map.fitBounds(bounds, { padding: 36, maxZoom: 13, duration: 0 });
    });
  }
  box.querySelector('[data-sd-show]').addEventListener('click', function () {
    var ld = box.querySelector('[data-sd-load]');
    ld.querySelector('button').disabled = true;
    ld.querySelector('p').textContent = 'Loading the map...';
    load(function () { ld.hidden = true; draw(); });
  });
})();
